import React from 'react';
import PropTypes from 'prop-types';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import {
  Section,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryTitle,
} from './styles';
import TextArea from '../../../shared/text-area';
import { usePostUpdateDisclaimer } from '../../../../services/profiles/contributor-settings-service';

export default function Disclaimer({ disclaimer }) {
  const [{ loading, error }, post] = usePostUpdateDisclaimer();

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving disclaimer');
  }, [error]);

  const label = 'Disclaimer';
  const taProps = {
    label,
    value: disclaimer,
    placeholder: label,
    limit: 0,
    isLoading: loading,
    onChange: post,
  };

  return (
    <>
      <SectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>{label}</SectionSummaryTitle>
        </SectionSummary>
        <SectionDetails>
          <TextArea {...taProps} />
        </SectionDetails>
      </Section>
    </>
  );
}

Disclaimer.propTypes = { disclaimer: PropTypes.string };
Disclaimer.defaultProps = { disclaimer: null };
